import { useState } from "react";
import "./style/style.css";
import emailjs from "emailjs-com";
import { config } from "../../config";

export function Contact() {
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState<string | null>(null);

  const [message, setMessage] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    question: "",
    message: "",
  });

  async function sendEmail() {
    setInfo(null);

    if (message.name === "" || message.name.length < 3) {
      setInfo("Please fill the blank(s)");
      return;
    }

    if (message.company === "" || message.company.length < 3) {
      setInfo("Please fill the blank(s)");
      return;
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(message.email)) {
      setInfo("Please enter valid email address");
      return;
    }

    setInfo(null);

    try {
      emailjs.init(config.email_key);
      setIsLoading(true);
      await emailjs.send(config.email_service, config.email_template, {
        from_name: message.name,
        from_email: message.email,
        from_phone: message.phone,
        message: message.message,
        from_company: message.company,
        from_question: message.question,
      });

      setInfo("Email has been sent.");
      setMessage({
        ...message,
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
      });
    } catch (error) {
      console.error("Something went wrong.", error);
    }

    setIsLoading(false);
  }

  return (
    <>
      <section className="contact_container" id="contact">
        <div className="contact">
          <div className="contact_header">
            <h1>Contact Information</h1>
            <h5>We are here for you!</h5>
          </div>

          <input
            placeholder="Name *"
            value={message.name}
            onChange={(e) => setMessage({ ...message, name: e.target.value })}
          />
          <input
            placeholder="Email *"
            value={message.email}
            onChange={(e) => setMessage({ ...message, email: e.target.value })}
          />
          <input
            placeholder="Phone"
            value={message.phone}
            onChange={(e) => setMessage({ ...message, phone: e.target.value })}
          />
          <input
            placeholder="Company *"
            value={message.company}
            onChange={(e) =>
              setMessage({ ...message, company: e.target.value })
            }
          />
          <input
            placeholder="Message"
            value={message.message}
            onChange={(e) =>
              setMessage({ ...message, message: e.target.value })
            }
          />

          <br />

          <div className="contact_header">
            <h1>Questions</h1>
            <h5>How did you hear about us ? </h5>
          </div>

          <select
            onChange={(e) =>
              setMessage({ ...message, question: e.target.value })
            }
          >
            <option value="exhibition">Exhibition</option>
            <option value="online-search">Online Search</option>
            <option value="social-media">Social Media</option>
            <option value="advertising">Advertising</option>
            <option value="recommendation">Recommendation</option>
            <option value="other">Other</option>
          </select>

          <br />
          {info && <span>{info}</span>}
          <button disabled={isLoading} onClick={sendEmail}>
            Get in touch
          </button>
        </div>
      </section>
    </>
  );
}
